var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadReceiptIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 11.3337C1.40033 11.3337 1.16699 11.2337 0.966992 11.0337C0.766992 10.8337 0.666992 10.6003 0.666992 10.3337V7.95033H1.66699V10.3337H10.3337V7.95033H11.3337V10.3337C11.3337 10.6003 11.2337 10.8337 11.0337 11.0337C10.8337 11.2337 10.6003 11.3337 10.3337 11.3337H1.66699ZM5.50033 8.78366V2.60033L3.50033 4.60033L2.78366 3.88366L6.00033 0.666992L9.21699 3.88366L8.50033 4.60033L6.50033 2.60033V8.78366H5.50033Z",
    fill: "#182C55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadReceiptIcon);
export default __webpack_public_path__ + "static/media/upload-receipt-icon.9215ff0e.svg";
export { ForwardRef as ReactComponent };